import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import './ImageIconButton.scss';

const ImageIconButton = props => {
  const { image, text, extra, ...rest } = props;
  return (
    <Button className="image-icon-button" color="primary" fullWidth={true} {...rest}>
      <Grid container spacing={1} sx={{ flexDirection: 'column' }}>
        <Grid>{image}</Grid>
        <Grid>{typeof text === 'string' ? <Typography color="textPrimary">{text}</Typography> : text}</Grid>
      </Grid>
      {extra && extra}
    </Button>
  );
};

export default ImageIconButton;
